import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePageTracking = () => {
  //  const location = useLocation();
  // useEffect(() => {
  //   // Envia os dados da rota atual para o Google Analytics
  //   window.gtag("config", "AW-16733526562", {
  //     page_path: location.pathname, // Define a rota como caminho da página
  //   });
  // }, [location]);
};

export default usePageTracking;
